import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function VulnerabilityReporting() {
  const { t } = useTranslation();
  return (
    <InfoPage
      eyebrow={t('info.securityEyebrow')}
      title={t('legalPages.vulnerability.title')}
      subtitle={t('legalPages.vulnerability.subtitle')}
    >
      {/* Legal text is deliberately NOT machine-translated: a translation
          nobody has legally reviewed would carry meaning no one signed off
          on. The chrome localizes; the binding text stays English, and says
          so in the reader's language. */}
      <p className="info-english-notice"><em>{t('info.englishNotice')}</em></p>
      <h2>Our Commitment</h2>
      <p>
        We take the security of StarView Cinema's website, app, and backend services seriously - including
        payment processing, account authentication, and ticket/seat integrity. We welcome reports from
        independent security researchers and will work with you in good faith to understand and resolve genuine
        issues.
      </p>

      <h2>How to Report</h2>
      <p>
        Email <a href="mailto:security@starviewcinema.com">security@starviewcinema.com</a> with as much detail as
        you can provide:
      </p>
      <ul>
        <li>A clear description of the issue and its potential impact.</li>
        <li>Step-by-step reproduction instructions, including the affected endpoint, screen, or feature.</li>
        <li>Any proof-of-concept code, screenshots, or request/response logs that help us verify it quickly.</li>
      </ul>
      <p>We aim to acknowledge every report within 3 business days.</p>

      <h2>Scope</h2>
      <p>In scope:</p>
      <ul>
        <li>Authentication, session, and account-takeover issues.</li>
        <li>Payment or Galaxies-balance manipulation.</li>
        <li>Seat/ticket integrity issues (e.g. double-booking a seat, bypassing showtime restrictions).</li>
        <li>Data exposure - personal information, driver application documents, or internal admin endpoints reachable without authorization.</li>
      </ul>
      <p>Out of scope:</p>
      <ul>
        <li>Reports requiring physical access to a device or social engineering of StarView staff.</li>
        <li>Denial-of-service testing against production systems - please describe the theoretical issue instead of running it.</li>
        <li>Issues in third-party services we integrate with (Stripe, app stores) - please report those directly to the vendor.</li>
      </ul>

      <h2>Safe Harbor</h2>
      <p>
        We won't pursue legal action against researchers who make a good-faith effort to follow this policy:
        avoid privacy violations, service disruption, and data destruction, and give us a reasonable window to
        fix an issue before any public disclosure.
      </p>
    </InfoPage>
  );
}
